import { getDataFromServer } from '../../../util';

export class RiskLevelChangeListModule {
  constructor(baseURL, httpHeaders) {
    this.baseURL = baseURL;
    this.httpHeaders = httpHeaders;
  }

  fetchRiskLevelChangeList = async (payload) => {
    const params = {
      metaName: 'risklevelchange'
    };

    const url = `${this.baseURL}/meta`;
    return await getDataFromServer(url, this.httpHeaders, params);
  };
}
